// extracted by mini-css-extract-plugin
module.exports = {"passenger":"Dg-uus8zHyaz","active":"mYXtMsQpTAYk","label":"_28CmomJWLng6","checkbox":"_2VXwCmMyaqQ4"};